export default __webpack_public_path__ + "static/media/vox-img-legacy-002.a120d3ea.jpg";